import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { QuotationDetailEnums } from 'src/app/enum/quotation-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { QuotationDetailService } from 'src/app/services/preliminaries/quotation-detail.service';
import { QuotationVersionService } from 'src/app/services/preliminaries/quotation-version.service';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { ImportBreakdownComponent } from '../../breakdown/import-breakdown/import-breakdown.component';
import { AttachImagesQuotationDetailComponent } from '../attach-images-quotation-detail/attach-images-quotation-detail.component';
import { DetailFromCompositeArticleComponent } from '../detail-from-composite-article/detail-from-composite-article.component';
import { CompositeArticleDetailSelectTableModel } from 'src/app/models/tables/preliminaries/composite-article-select-detail-table.model';

@Component({
  selector: 'app-register-quotation-detail',
  templateUrl: './register-quotation-detail.component.html',
  styleUrls: ['./register-quotation-detail.component.scss'],
  standalone: false
})
export class RegisterQuotationDetailComponent implements OnInit {
  @ViewChild('importBreakdown') importModalComponent?: CustomModalComponent | null = null;
  @ViewChild('compositeArticle') compositeArticleModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachImages') attachImagesModalComponent?: CustomModalComponent | null = null;

  codeNameBranch: string = '';
  breakpointsForImport: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  nameWindow: string = 'Captura Soluciones - Cotizaciones';
  formQuotationSolution: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  inputsForImport$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
    breakdownsInSolution: false
  });
  inputsForMasterSolution$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
    quotationVersionId: null
  });
  inputsForAttachImages$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
  });
  outputImport$ = new Subject<any>();
  outputMasterSolution$ = new Subject<any>();
  outputAttachImages$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  breakdownsInSolution: boolean = false;
  projectName = ProjectName.projectName;
  quotationId: number = 0;
  quotationSolutionId: number = 0;
  versionId: number = 0;
  quotationContract: QuotationModel = new QuotationModel();
  quotationTypeName: string = '';
  quotationSolutionContract: QuotationDetailModel = new QuotationDetailModel();
  quotationVersionContract: QuotationVersionModel = new QuotationVersionModel();
  totalsBreakdowns: number = 0;
  userAuthenticated: UserModel = new UserModel();
  url: string = "quotation";
  updateTableBreakdown: boolean = false;
  listUnits: any[] = [];
  listCostCenters: any[] = [];
  listBaseValue: any[] = [];
  permissionsUser: OptionWindowModel[] = [];
  subscription: Subscription;

  componentImportBreakdown = ImportBreakdownComponent;
  componentCompositeArticle = DetailFromCompositeArticleComponent;
  componentAttachImages = AttachImagesQuotationDetailComponent;

  constructor(private activatedRoute: ActivatedRoute,
    private breakdownService: BreakdownService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private quotationService: QuotationService,
    private quotationSolutionService: QuotationDetailService,
    private quotationVersionService: QuotationVersionService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService
  ) { }

  async ngOnInit() {
    await this.validateForm(new QuotationDetailModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();

    this.activatedRoute.params.subscribe(params => {
      const quotationId = params['id'] ?? 0;
      this.quotationId = Number(quotationId);

      const quotationSolutionId = params['solutionId'] ?? 0;
      this.quotationSolutionId = Number(quotationSolutionId);
    });

    this.activatedRoute.queryParams.subscribe(params => {
      const versionId = params['version'];
      this.versionId = Number(versionId);
    });

    await this.handleInitialState();

    this.subscription = this.outputImport$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getQuotationDetailById();
          this.updateTableBreakdown = true;
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputMasterSolution$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'quotationDetailId':
          this.quotationSolutionId = payload
          this.getQuotationDetailById();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputAttachImages$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'updateQuotationSolutionModel':
          this.quotationSolutionContract = payload
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  calculateTotalsValue(): void {
    const subtotalValue = this.formQuotationSolution.get("subtotalValue")?.value ?? 0;
    const days = this.formQuotationSolution.get("days")?.value ?? 0;
    const ivaRate = this.formQuotationSolution.get("ivaRate")?.value ?? 0;

    const totalValue = subtotalValue * days;
    const ivaValue = totalValue * (ivaRate / 100);
    const totalWithIva = totalValue + ivaValue;

    // helper para redondear a 2 decimales
    const round2 = (val: number) => Math.round((val + Number.EPSILON) * 100) / 100;

    this.formQuotationSolution.patchValue({
      totalValue: round2(totalValue),
      ivaValue: round2(ivaValue),
      totalWithIva: round2(totalWithIva)
    }, { emitEvent: false });
  }


  async createNewSolution() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear cotizaciones. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    this.quotationSolutionId = 0;
    this.quotationSolutionContract = new QuotationDetailModel();
    await this.validateForm(this.quotationSolutionContract);
    this.breakdownsInSolution = false;
    this.location.replaceState(`/quotation/register/${this.quotationId}/solution?version=${this.versionId}`);
  }

  async createBreakdownFromMasterSolutionAsync(compositeArticleId: number, compositeArticleDetailIds: number[]) {
    try {
      await firstValueFrom(
        this.breakdownService.createBreakdownFromMasterSolutionAsync(
          this.versionId, this.quotationSolutionContract.quotationDetailId, compositeArticleId, compositeArticleDetailIds
        )
      );
      this.toastHandlerService.showToast(
        'success',
        'Se procesó el artículo compuesto exitosamente.'
      );
      await this.getQuotationDetailById();
    } catch (error) {
      console.error('Error al procesar el artículo compuesto.', error);
    }
  }

  async deleteSolution() {
    if (this.breakdownsInSolution) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible eliminar, la solución tiene despiece.'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar la solución?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(
          this.quotationSolutionService.deleteQuotationDetail(this.quotationSolutionContract.quotationDetailId)
        );
        this.toastHandlerService.showToast(
          'success',
          'La solución fue eliminada exitosamente.'
        );
        this.createNewSolution();
      } catch (error) {
        console.error('Error al eliminar la solución.', error);
      }
    }
  }

  async handleInitialState() {
    await this.getQuotationAndVersionById();
    if (this.quotationSolutionId !== null && this.quotationSolutionId !== 0) {
      await this.getQuotationDetailById();
    } else {
      this.createNewSolution();
    }
  }

  private async handleQuotationDetailNavigation(buttonClick: any, versionId: number, quotationSolutionId: number | null) {
    const actionMap: Record<string, () => Promise<QuotationDetailModel>> = {
      first: () =>
        firstValueFrom(
          this.quotationSolutionService.getFirstQuotationDetailByKeysAsync(versionId)
        ),
      previus: () =>
        firstValueFrom(
          this.quotationSolutionService.getPreviusQuotationDetailByKeysAsync(versionId, quotationSolutionId)
        ),
      next: () =>
        firstValueFrom(
          this.quotationSolutionService.getNextQuotationDetailByKeysAsync(versionId, quotationSolutionId)
        ),
      last: () =>
        firstValueFrom(
          this.quotationSolutionService.getLastQuotationDetailByKeysAsync(versionId)
        )
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      return;
    }

    try {
      const quotationSolution = await action();
      this.quotationSolutionContract = quotationSolution;
      this.quotationSolutionId = quotationSolution.quotationDetailId;
      await this.validateForm(quotationSolution);
      this.location.replaceState(`/quotation/register/${this.quotationId}/solution/${this.quotationSolutionId}?version=${this.versionId}`);


    } catch (error) {
      console.error(`Error al buscar la solución (${buttonClick.target.id}).`, error);
    }
  }

  async handleImportBreakdown(selectedItems: CompositeArticleDetailSelectTableModel[]) {
    if (!selectedItems?.length) return;
    const compositeArticleId = selectedItems[0].compositeArticleId;
    const compositeArticleDetailIds = selectedItems.map(item => item.compositeArticleDetailId);
    await this.createBreakdownFromMasterSolutionAsync(compositeArticleId, compositeArticleDetailIds);
  }

  private async loadQuotationData() {
    const [quotation, version] = await Promise.all([
      firstValueFrom(this.quotationService.getQuotationById(this.quotationId)),
      firstValueFrom(this.quotationVersionService.getQuotationVersionById(this.versionId)),
    ]);

    this.quotationContract = quotation;
    this.quotationVersionContract = version;
  }

  openImportBreakdown() {
    const userImport = this.permissionsUser.find(x => x.code != OptionWindow.Importar);
    if (this.userAuthenticated.profileUser.code != ProfileUserEnums.administrador
      || userImport || !this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para importar Despiece de Solución, comuniquese con el administrador del sistema.'
      );
      return;
    }

    if (!this.quotationSolutionContract.swBreakdown) {
      this.toastHandlerService.showToast(
        'warning',
        'La solución seleccionada NO tiene activo el campo de despiece.'
      );
      return;
    }

    if (this.breakdownsInSolution) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible importar. Existen artículos agregados al despiece.'
      );
      return;
    }

    this.updateImportInputs();
    this.importModalComponent && this.importModalComponent.show();
  }

  openCompositeArticle() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para importar desde artículos compuestos, comuniquese con el administrador del sistema.'
      );
      return;
    }
    if (this.breakdownsInSolution) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible desde artículos compuestos. Existen artículos agregados al despiece.'
      );
      return;
    }
    this.compositeArticleModalComponent?.show();
  }

  openAttachImages() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para adjuntar Imágenes, comuniquese con el administrador del sistema.'
      );
      return;
    }

    this.updateAttachImagesInputs();
    this.attachImagesModalComponent && this.attachImagesModalComponent.show();
  }

  async getAllLists() {
    try {
      const [units, baseValue] = await Promise.all([
        firstValueFrom(this.quotationSolutionService.getAllUnitsForSelect()),
        firstValueFrom(this.quotationSolutionService.getAllBaseValueForSelect()),
      ]);
      this.listUnits = units;
      this.listBaseValue = baseValue;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  getButtonClick(buttonClick: any) {
    let quotationSolutionId = this.formQuotationSolution.get("quotationDetailId")?.value;
    if (this.versionId == null || this.versionId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La versión no es válida.'
      );
      return;
    }
    quotationSolutionId = quotationSolutionId === 0 ? null : quotationSolutionId;
    this.handleQuotationDetailNavigation(buttonClick, this.versionId, quotationSolutionId);
  }

  async getCostCenter(costCenterId: number | null) {
    const previousCostCenterId = this.quotationSolutionContract.costCenterId;
    if (previousCostCenterId === costCenterId) {
      return;
    }

    if (costCenterId) {
      this.formQuotationSolution.controls["costCenterId"].patchValue(costCenterId);
    } else {
      if (this.quotationSolutionContract.swBreakdown) {
        this.toastHandlerService.showToast(
          'warning',
          'No es posible limpiar el c.costos, la solución tiene despiece.'
        );
        return;
      }
      this.formQuotationSolution.controls["costCenterId"].patchValue(null);
    }
  }


  async getAllCostCenterForSelect(constructionSiteId: number) {
    try {
      this.listCostCenters = await firstValueFrom(
        this.quotationSolutionService.getAllCostCenterForSelect(constructionSiteId)
      );
    } catch (error) {
      console.error('Error al buscar la cotización.', error);
    }
  }

  getBaseValue(baseValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value ?? 0;
    const swBreakdown = this.formQuotationSolution.get("swBreakdown")?.value;

    if (baseValue == QuotationDetailEnums.UnitValue) {
      const unitValue = this.formQuotationSolution.get("subtotalValue")?.value;
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);

      const subtotalValue = unitValue * quantity
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    } else {
      const subtotalValue = this.formQuotationSolution.get("unitValue")?.value;
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);

      const unitValue = subtotalValue / quantity;
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    }
    this.updateControlsByBaseValue(swBreakdown);
    this.calculateTotalsValue();

  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      // windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(
        this.windowService.getPermissionProfileByUrl(this.url)
      );
      await this.getUserAuthenticatedService();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  getQuantity(quantity: number) {
    const baseValue = this.formQuotationSolution.get("baseValue")?.value;

    if (baseValue == QuotationDetailEnums.UnitValue) {
      const unitValue = this.formQuotationSolution.get("unitValue")?.value;
      const subtotalValue = unitValue * quantity
      this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    } else {
      const subtotalValue = this.formQuotationSolution.get("subtotalValue")?.value;
      const unitValue = subtotalValue / quantity
      this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    }

    this.calculateTotalsValue();
  }

  async getQuotationAndVersionById() {
    try {
      if (!this.quotationId || !this.versionId) {
        return;
      }

      const [quotation, version] = await Promise.all([
        firstValueFrom(this.quotationService.getQuotationById(this.quotationId)),
        firstValueFrom(this.quotationVersionService.getQuotationVersionById(this.versionId)),
      ]);

      this.quotationContract = quotation;
      this.quotationVersionContract = version;

      const branch = await firstValueFrom(
        this.quotationService.getBranchByIdForSelect(this.quotationContract.branchId)
      );
      const quotationType = await firstValueFrom(
        this.quotationService.getQuotationTypeByIdForSelect(this.quotationContract.quotationTypeId)
      );

      this.codeNameBranch = branch.label;
      this.quotationTypeName = quotationType.label;

      if (this.quotationContract.constructionSiteId != null) {
        await this.getAllCostCenterForSelect(this.quotationContract.constructionSiteId);
      }
    } catch (error) {
      console.error('Error al buscar la cotización y la versión.', error);
    }
  }

  async getQuotationDetailById() {
    try {
      this.quotationSolutionContract = await firstValueFrom(
        this.quotationSolutionService.getQuotationDetailById(this.quotationSolutionId)
      );
      this.quotationSolutionId = this.quotationSolutionContract.quotationDetailId;
      await this.validateForm(this.quotationSolutionContract);

    } catch (error) {
      console.error('Error al buscar la cotización.', error);
    }
  }

  async getSwBreakdown(swBreakdown: boolean) {
    if (swBreakdown) {
      setTimeout(() => this.formControlStateService.setControlState(this.formQuotationSolution, ['unitValue', 'subtotalValue'], false), 100);
    } else {
      this.totalsBreakdowns = await firstValueFrom(
        this.breakdownService.getTotalBreakdownByQuotationDetailId(this.quotationSolutionId)
      );
      if (this.totalsBreakdowns > 0) {
        this.formQuotationSolution.controls["swBreakdown"].patchValue(true);
        this.toastHandlerService.showToast(
          'warning',
          `No es posible cambiar el despiece. La solución tiene artículos relacionados.`
        );
        return;
      }
      this.updateControlsByBaseValue(swBreakdown);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/quotation/register/${this.quotationId}`]);
  }

  getSubtotalValue(subtotalValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value;
    const unitValue = subtotalValue * quantity;
    this.formQuotationSolution.controls["unitValue"].patchValue(unitValue);
    this.calculateTotalsValue();
  }

  getUnitValue(unitValue: number) {
    const quantity = this.formQuotationSolution.get("quantity")?.value;
    const subtotalValue = unitValue * quantity;
    this.formQuotationSolution.controls["subtotalValue"].patchValue(subtotalValue);
    this.calculateTotalsValue();
  }


  async getUserAuthenticatedService() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(
      this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Quotation)
    );
  }


  async send() {
    Object.keys(this.formQuotationSolution.controls).forEach(key => {
      const control = this.formQuotationSolution.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formQuotationSolution.valid) {
      const modelQuotationSolution = this.formQuotationSolution.getRawValue();
      if (typeof (this.quotationSolutionContract.costCenterId) == 'string') {
        this.toastHandlerService.showToast(
          'warning',
          'El centro de costos no es válido. Verifique que exista en la lista de centros de costos.'
        );
        return;
      }

      if (modelQuotationSolution.costCenterId === '') modelQuotationSolution.costCenterId = null;

      if (this.quotationSolutionId == 0) {
        modelQuotationSolution.quotationId = this.quotationId;
        modelQuotationSolution.quotationVersionId = this.versionId;
        try {
          this.quotationSolutionContract = await firstValueFrom(
            this.quotationSolutionService.createQuotationDetail(modelQuotationSolution)
          );
          this.toastHandlerService.showToast(
            'success',
            'La solución fue creada exitosamente'
          );
          this.quotationSolutionId = this.quotationSolutionContract.quotationDetailId;
          await this.validateForm(this.quotationSolutionContract);
        } catch (error) {
          console.error('Error al crear la solución.', error);
        }
      } else {

        this.quotationSolutionContract.costCenterId = modelQuotationSolution.costCenterId;
        this.quotationSolutionContract.solutionCode = modelQuotationSolution.solutionCode;
        this.quotationSolutionContract.solutionName = modelQuotationSolution.solutionName;
        this.quotationSolutionContract.swBreakdown = modelQuotationSolution.swBreakdown;
        this.quotationSolutionContract.baseValue = modelQuotationSolution.baseValue;
        this.quotationSolutionContract.unitId = modelQuotationSolution.unitId;
        this.quotationSolutionContract.unitValue = modelQuotationSolution.unitValue;
        this.quotationSolutionContract.quantity = modelQuotationSolution.quantity;
        this.quotationSolutionContract.subtotalValue = modelQuotationSolution.subtotalValue;
        this.quotationSolutionContract.days = modelQuotationSolution.days;
        this.quotationSolutionContract.totalValue = modelQuotationSolution.totalValue;
        this.quotationSolutionContract.ivaRate = modelQuotationSolution.ivaRate;
        this.quotationSolutionContract.ivaValue = modelQuotationSolution.ivaValue;
        try {
          this.quotationSolutionContract = await firstValueFrom(
            this.quotationSolutionService.updateQuotationDetail(this.quotationSolutionContract)
          );
          this.toastHandlerService.showToast(
            'success',
            'La solución fue modificada exitosamente'
          );
          await this.validateForm(this.quotationSolutionContract);
        } catch (error) {
          console.error('Error al actualizar la solución.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      solutionCode: {
        required: 'El campo solución es obligatorio.'
      },
      baseValue: {
        required: 'El campo valor base es obligatorio.',
        min: 'Debe seleccionar al menos un valor base.'
      },
      unitId: {
        required: 'El campo unidad es obligatorio.',
        min: 'Debe seleccionar al menos una unidad.'
      },
      quantity: {
        required: 'El campo cantidad es obligatorio.',
        min: 'Debe ingresar mínimo una cantidad.'
      },
      days: {
        required: 'El campo días es obligatorio.',
        min: 'Debe ingresar mínimo un día.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formQuotationSolution.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  private updateControlsByBaseValue(swBreakdown: boolean): void {
    const baseValue = this.formQuotationSolution.get("baseValue")?.value;

    const [enable, disable] = baseValue === QuotationDetailEnums.UnitValue
      ? ['unitValue', 'subtotalValue'] : ['subtotalValue', 'unitValue'];

    Promise.resolve().then(() => {
      this.formControlStateService.setControlState(this.formQuotationSolution, [disable], false);
      this.formControlStateService.setControlState(this.formQuotationSolution, [enable], swBreakdown ? false : true);
    });
  }

  updateImportInputs() {
    this.inputsForImport$.next({
      quotationSolutionModel: this.quotationSolutionContract,
      breakdownsInSolution: this.breakdownsInSolution
    });
  }

  updateAttachImagesInputs() {
    this.inputsForAttachImages$.next({
      quotationSolutionModel: this.quotationSolutionContract,
    });
  }

  validateForm(quotationSolution: QuotationDetailModel) {
    this.formQuotationSolution = this.formBuilder.group({
      quotationId: [quotationSolution.quotationId, []],
      quotationVersionId: [quotationSolution.quotationVersionId, []],
      quotationDetailId: [quotationSolution.quotationDetailId, []],
      costCenterId: [quotationSolution.costCenterId, []],
      solutionCode: [quotationSolution.solutionCode, [Validators.required]],
      solutionName: [quotationSolution.solutionName, []],
      swBreakdown: [quotationSolution.swBreakdown, []],
      baseValue: [quotationSolution.baseValue, [Validators.required, Validators.min(1)]],
      unitId: [quotationSolution.unitId, [Validators.required, Validators.min(1)]],
      unitValue: [quotationSolution.unitValue, []],
      quantity: [quotationSolution.quantity, [Validators.required, Validators.min(1)]],
      subtotalValue: [quotationSolution.subtotalValue, []],
      days: [quotationSolution.days, [Validators.required, Validators.min(1)]],
      totalValue: [quotationSolution.totalValue, []],
      ivaRate: [quotationSolution.ivaRate, []],
      ivaValue: [quotationSolution.ivaValue, []],
      totalWithIva: [[quotationSolution.totalValue + quotationSolution.ivaValue]]
    });
    this.formControlStateService.setControlState(this.formQuotationSolution, ['totalValue', 'ivaValue', 'totalWithIva'], false);
    this.updateControlsByBaseValue(quotationSolution.swBreakdown);
  }
}
